export enum RecurringPaymentAmountTypeEnum {
  Minimum = 1,
  Maximum,
  Custom
}
